import * as React from "react";
import { Solo } from "../../../models/Solo";
import { Unit } from "../../../models/Unit";


export interface SoloGeneratorProps {
}


export interface SoloGeneratorState {
  useCost590: boolean;
  useCost560: boolean;
  useCost450: boolean;
  useCost420: boolean;
  useCost280: boolean;
  useCost270: boolean;
  useCost200: boolean;

  p1: Unit | undefined;
}


export class SoloGenerator extends React.Component<SoloGeneratorProps, SoloGeneratorState> {
  constructor(props: SoloGeneratorProps) {
    super(props);

    this.state = {
      useCost590: true,
      useCost560: true,
      useCost450: true,
      useCost420: true,
      useCost280: true,
      useCost270: true,
      useCost200: true,

      p1: undefined,
    };
  }


  onGenerate() {
    const p1 = Solo.random({
      useCost590: this.state.useCost590,
      useCost560: this.state.useCost560,
      useCost450: this.state.useCost450,
      useCost420: this.state.useCost420,
      useCost280: this.state.useCost280,
      useCost270: this.state.useCost270,
      useCost200: this.state.useCost200,
    });

    this.setState({
      p1,
    });
  }

  render() {
    const disabled = !(this.state.useCost200 || this.state.useCost270 || this.state.useCost280 || this.state.useCost420 || this.state.useCost450 || this.state.useCost560 || this.state.useCost590);

    const p1_name = this.state.p1 ? `${this.state.p1.name}` : `----`;
    const p1_cost = this.state.p1 ? `${this.state.p1.cost}` : `----`;

    return (
      <>
        <form>
          <div className="form-group row">
            <div className="offset-md-2 col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-590"
                        checked={this.state.useCost590}
                        onChange={e => {
                          this.setState({
                            useCost590: !this.state.useCost590,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-590">
                  590
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-560"
                        checked={this.state.useCost560}
                        onChange={e => {
                          this.setState({
                            useCost560: !this.state.useCost560,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-560">
                  560
                </label>
              </div>
            </div>
          </div>


          <div className="form-group row">
            <div className="offset-md-2 col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-450"
                        checked={this.state.useCost450}
                        onChange={e => {
                          this.setState({
                            useCost450: !this.state.useCost450,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-450">
                  450
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-420"
                        checked={this.state.useCost420}
                        onChange={e => {
                          this.setState({
                            useCost420: !this.state.useCost420,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-420">
                  420
                </label>
              </div>
            </div>
          </div>


          <div className="form-group row">
            <div className="offset-md-2 col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-280"
                        checked={this.state.useCost280}
                        onChange={e => {
                          this.setState({
                            useCost280: !this.state.useCost280,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-280">
                  280
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-270"
                        checked={this.state.useCost270}
                        onChange={e => {
                          this.setState({
                            useCost270: !this.state.useCost270,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-270">
                  270
                </label>
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="use-cost-200"
                        checked={this.state.useCost200}
                        onChange={e => {
                          this.setState({
                            useCost200: !this.state.useCost200,
                          });
                        }}/>
                <label className="form-check-label" htmlFor="use-cost-200">
                  200
                </label>
              </div>
            </div>
          </div>


          <div className="form-group row">
            <div className="offset-md-2 col-md-3">
              <button className="btn btn-outline-primary btn-block"
                      disabled={disabled}
                      onClick={e => {
                        e.preventDefault();

                        this.onGenerate();
                      }}>
                生成
              </button>
            </div>

            <div className="col-md-3">
              <button className="btn btn-outline-primary btn-block"
                      onClick={e => {
                        e.preventDefault();

                        this.setState({
                          useCost590: false,
                          useCost560: false,
                          useCost450: false,
                          useCost420: false,
                          useCost280: false,
                          useCost270: false,
                          useCost200: false,
                        });
                      }}>
                全て解除
              </button>
            </div>

            <div className="col-md-3">
              <button className="btn btn-outline-primary btn-block"
                      onClick={e => {
                        e.preventDefault();

                        this.setState({
                          useCost590: true,
                          useCost560: true,
                          useCost450: true,
                          useCost420: true,
                          useCost280: true,
                          useCost270: true,
                          useCost200: true,
                        });
                      }}>
                すべて選択
              </button>
            </div>
          </div>
        </form>


        <h3>
          結果
        </h3>

        <form>
          <div className="form-group row">
            <label htmlFor="p1_name" className="col-md-2 col-form-label">
              P1
            </label>
            <div className="col-md-6">
              <input type="text" readOnly className="form-control-plaintext" id="p1_name" value={p1_name}/>
            </div>
            <div className="col-md-4">
              <input type="text" readOnly className="form-control-plaintext" id="p1_cost" value={p1_cost}/>
            </div>
          </div>
        </form>
      </>
    );
  }
}
